import React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'svgxuse';
import App from './App';
import { createRoot } from 'react-dom/client';

// if (process.env.NODE_ENV !== 'production' && window.Cypress) {
//     new ExternalSvgPolyfill();
// }

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);
